import { render, staticRenderFns } from "./EmployeeListItemSkeleton.vue?vue&type=template&id=d6be1448&scoped=true"
import script from "./EmployeeListItemSkeleton.vue?vue&type=script&lang=ts"
export * from "./EmployeeListItemSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6be1448",
  null
  
)

export default component.exports